import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_ENDPOINTS } from '../config/api';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [heroImages, setHeroImages] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [contactInfo, setContactInfo] = useState({
    location: 'Lytei Estate, Block 2, off Makutano-Lytei Road',
    address: 'P. O BOX 663- 30600, Kapenguria, Kenya',
    email: 'info@sikompeace.org',
    email2: 'sikompeace@yahoo.com',
    phone: '+254711538258',
    phone2: '+25404387440',
    facebookUrl: '#',
    twitterUrl: '#',
    linkedinUrl: '#',
    instagramUrl: '#'
  });
  const [mapSettings, setMapSettings] = useState({
    enabled: true,
    latitude: '1.2564966',
    longitude: '35.0846095',
    location: 'Lytei Estate, Block 2, off Makutano-Lytei Road, Kapenguria, Kenya',
    googleUrl: 'https://maps.app.goo.gl/EnqTEvqdQG2qstRs9',
    markerName: 'SIKOM Peace Network for Development'
  });

  useEffect(() => {
    fetchHeroImages();
    fetchContactSettings();
    
    // Auto-slide hero images
    const heroInterval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % (heroImages.length || 1));
    }, 5000);

    return () => {
      clearInterval(heroInterval);
    };
  }, [heroImages.length]);

  const fetchHeroImages = async () => {
    try {
      const response = await axios.get(API_ENDPOINTS.HERO_IMAGES, {
        params: { is_active: 1 }
      });
      if (response.data.success) {
        setHeroImages(response.data.data.map(img => img.image_path));
      } else {
        setHeroImages([
          '/images/hero1.jpg',
          '/images/hero2.jpg',
          '/images/hero3.jpg'
        ]);
      }
    } catch (error) {
      console.error('Error fetching hero images:', error);
      setHeroImages([
        '/images/hero1.jpg',
        '/images/hero2.jpg',
        '/images/hero3.jpg'
      ]);
    }
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const fetchContactSettings = async () => {
    try {
      const response = await axios.get(API_ENDPOINTS.SETTINGS);
      if (response.data.success) {
        const s = response.data.data;
        
        setContactInfo({
          location: s.contact_location || s.contact_map_location || 'Lytei Estate, Block 2, off Makutano-Lytei Road',
          address: s.contact_address || 'P. O BOX 663- 30600, Kapenguria, Kenya',
          email: s.contact_email || 'info@sikompeace.org',
          email2: s.contact_email2 || '',
          phone: s.contact_phone || '+254711538258',
          phone2: s.contact_phone2 || '',
          facebookUrl: s.facebook_url || '#',
          twitterUrl: s.twitter_url || '#',
          linkedinUrl: s.linkedin_url || '#',
          instagramUrl: s.instagram_url || '#'
        });
        
        const lat = s.contact_map_latitude || '1.2564966';
        const lng = s.contact_map_longitude || '35.0846095';
        
        setMapSettings({
          enabled: s.contact_map_enabled !== '0' && s.contact_map_enabled !== 'false',
          latitude: lat,
          longitude: lng,
          location: s.contact_map_location || 'Lytei Estate, Block 2, off Makutano-Lytei Road, Kapenguria, Kenya',
          googleUrl: s.contact_map_google_url || 'https://maps.app.goo.gl/EnqTEvqdQG2qstRs9',
          markerName: s.contact_map_marker_name || s.site_name || 'SIKOM Peace Network for Development'
        });
      }
    } catch (error) {
      console.error('Error fetching contact settings:', error);
    }
  };

  const getMapEmbedUrl = () => {
    // Use coordinates with organization name for map marker
    if (mapSettings.latitude && mapSettings.longitude) {
      const lat = parseFloat(mapSettings.latitude);
      const lng = parseFloat(mapSettings.longitude);
      if (!isNaN(lat) && !isNaN(lng)) {
        const markerName = (mapSettings.markerName || 'SIKOM Peace Network for Development').replace(/\s+/g, '+');
        return `https://www.google.com/maps?q=${markerName}+@${lat},${lng}&z=17&output=embed&hl=en&t=m`;
      }
    }
    
    if (mapSettings.location) {
      const locationQuery = encodeURIComponent(mapSettings.location);
      return `https://www.google.com/maps?q=${locationQuery}&output=embed&z=16&hl=en`;
    }
    
    return `https://www.google.com/maps?q=SIKOM+Peace+Network+@1.2564966,35.0846095&z=17&output=embed&hl=en&t=m`;
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      const response = await axios.post(API_ENDPOINTS.CONTACT, formData);
      
      if (response.data.success) {
        setSuccess(true);
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: ''
        });
      } else {
        setError(response.data.message || 'Failed to send message');
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <style>{`
        .hero-section {
          min-height: 60vh;
          position: relative;
          overflow: hidden;
        }

        .hero-slider {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 0;
        }

        .hero-slide {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-size: cover;
          background-position: center;
          transition: opacity 1.5s ease-in-out, transform 8s ease-out;
        }

        .hero-slide.active {
          animation: kenBurns 8s ease-out;
        }

        @keyframes kenBurns {
          0% { transform: scale(1); }
          100% { transform: scale(1.1); }
        }

        .slider-dot {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          border: 2px solid white;
          background: transparent;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .slider-dot.active {
          background: white;
          transform: scale(1.2);
        }
      `}</style>
      
      {/* Hero */}
      <section className="hero-section position-relative text-white">
        {/* Background Image Slider */}
        <div className="hero-slider">
          {heroImages.map((image, index) => (
            <div
              key={index}
              className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
              style={{
                backgroundImage: `url(${image})`,
                opacity: index === currentSlide ? 1 : 0,
                transform: index === currentSlide ? 'scale(1)' : 'scale(1.1)',
              }}
            />
          ))}
          
          {/* Overlay */}
          <div 
            className="position-absolute top-0 start-0 w-100 h-100"
            style={{
              background: 'linear-gradient(135deg, rgba(13, 110, 253, 0.85) 0%, rgba(108, 117, 125, 0.75) 100%)'
            }}
          />
        </div>

        {/* Content */}
        <div className="container position-relative" style={{ zIndex: 2, paddingTop: '100px', paddingBottom: '100px' }}>
          <h1 className="display-4 fw-bold">Contact Us</h1>
          <p className="lead">Let's connect! We would like to hear from you.</p>
        </div>

        {/* Slider Indicators */}
        <div 
          className="position-absolute bottom-0 start-50 translate-middle-x mb-4"
          style={{ zIndex: 3 }}
        >
          <div className="d-flex gap-2">
            {heroImages.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`slider-dot ${index === currentSlide ? 'active' : ''}`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 mb-5 mb-lg-0">
              <div className="card border-0 shadow-sm">
                <div className="card-body p-4 p-lg-5">
                  <h2 className="h3 mb-4">Send us a Message</h2>
                  
                  {success && (
                    <div className="alert alert-success">
                      Your message has been sent successfully! We'll get back to you soon.
                    </div>
                  )}
                  
                  {error && (
                    <div className="alert alert-danger">{error}</div>
                  )}
                  
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="name" className="form-label">Your Name *</label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      
                      <div className="col-md-6 mb-3">
                        <label htmlFor="email" className="form-label">Your Email *</label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="phone" className="form-label">Phone Number</label>
                        <input
                          type="tel"
                          className="form-control"
                          id="phone"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                        />
                      </div>
                      
                      <div className="col-md-6 mb-3">
                        <label htmlFor="subject" className="form-label">Subject *</label>
                        <input
                          type="text"
                          className="form-control"
                          id="subject"
                          name="subject"
                          value={formData.subject}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    
                    <div className="mb-4">
                      <label htmlFor="message" className="form-label">Message *</label>
                      <textarea
                        className="form-control"
                        id="message"
                        name="message"
                        rows="6"
                        value={formData.message}
                        onChange={handleChange}
                        required
                      ></textarea>
                    </div>
                    
                    <button
                      type="submit"
                      className="btn btn-primary btn-lg"
                      disabled={loading}
                    >
                      {loading ? 'Sending...' : 'Send Message'}
                    </button>
                  </form>
                </div>
              </div>
            </div>
            
            <div className="col-lg-4">
              <div className="card border-0 shadow-sm mb-4">
                <div className="card-body">
                  <h5 className="card-title mb-4">
                    <i className="bi bi-geo-alt text-primary me-2"></i>
                    Visit Us
                  </h5>
                  <p className="mb-2">
                    <strong>Location:</strong><br />
                    {contactInfo.location}
                  </p>
                  <p className="mb-2">
                    <strong>Address:</strong><br />
                    {contactInfo.address}
                  </p>
                  <a 
                    href={mapSettings.googleUrl || `https://maps.google.com/?q=${encodeURIComponent(contactInfo.location)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-primary btn-sm mt-2"
                  >
                    View on Google Maps
                  </a>
                </div>
              </div>
              
              <div className="card border-0 shadow-sm mb-4">
                <div className="card-body">
                  <h5 className="card-title mb-4">
                    <i className="bi bi-envelope text-primary me-2"></i>
                    Mail Us
                  </h5>
                  <p className="mb-1">
                    <i className="bi bi-envelope me-2"></i>
                    <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
                  </p>
                  {contactInfo.email2 && (
                    <p className="mb-1">
                      <i className="bi bi-envelope me-2"></i>
                      <a href={`mailto:${contactInfo.email2}`}>{contactInfo.email2}</a>
                    </p>
                  )}
                </div>
              </div>
              
              <div className="card border-0 shadow-sm">
                <div className="card-body">
                  <h5 className="card-title mb-4">
                    <i className="bi bi-telephone text-primary me-2"></i>
                    Call Us
                  </h5>
                  <p className="mb-2">
                    <i className="bi bi-phone me-2"></i>
                    <a href={`tel:${contactInfo.phone}`}>{contactInfo.phone}</a>
                  </p>
                  {contactInfo.phone2 && (
                    <p className="mb-0">
                      <i className="bi bi-phone me-2"></i>
                      <a href={`tel:${contactInfo.phone2}`}>{contactInfo.phone2}</a>
                    </p>
                  )}
                </div>
              </div>
              
              <div className="card border-0 shadow-sm mt-4">
                <div className="card-body">
                  <h5 className="card-title mb-3">Follow Us</h5>
                  <div className="d-flex gap-3">
                    <a href={contactInfo.facebookUrl} target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary">
                      <i className="bi bi-facebook"></i>
                    </a>
                    <a href={contactInfo.twitterUrl} target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary">
                      <i className="bi bi-twitter"></i>
                    </a>
                    <a href={contactInfo.linkedinUrl} target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary">
                      <i className="bi bi-linkedin"></i>
                    </a>
                    {contactInfo.instagramUrl && contactInfo.instagramUrl !== '#' && (
                      <a href={contactInfo.instagramUrl} target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary">
                        <i className="bi bi-instagram"></i>
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Office Location Map - Above Footer */}
      {mapSettings.enabled && (
        <section className="py-5" style={{ background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)' }}>
          <div className="container">
            <div className="row mb-4">
              <div className="col-12 text-center">
                <h2 className="display-5 fw-bold mb-3">Our Office Location</h2>
                {mapSettings.markerName && (
                  <p className="h5 text-primary mb-2">
                    <i className="bi bi-pin-map-fill me-2"></i>
                    {mapSettings.markerName}
                  </p>
                )}
                <p className="lead text-muted mb-0">
                  <i className="bi bi-geo-alt-fill text-primary me-2"></i>
                  {mapSettings.location}
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="card border-0 shadow-lg overflow-hidden" style={{ borderRadius: '15px' }}>
                  <div className="ratio ratio-21x9" style={{ minHeight: '450px' }}>
                    <iframe
                      src={getMapEmbedUrl()}
                      width="100%"
                      height="450"
                      style={{ border: 0, width: '100%', height: '100%' }}
                      allowFullScreen={true}
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="SIKOM Office Location"
                    ></iframe>
                  </div>
                </div>
                <div className="text-center mt-4">
                  <a
                    href={mapSettings.googleUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-primary btn-lg"
                  >
                    <i className="bi bi-map me-2"></i>
                    Open in Google Maps
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default Contact;